(function () {
  'use strict';

  const APPSTLE_ACTIVE_PRICE_SEL =
    '.appstle-active-option .appstle_subscription_amount:not(.sr-only)';
  const APPSTLE_ONETIME_PRICE_SEL =
    '.appstle_one_time_price_wrapper .appstle_subscription_amount:not(.sr-only)';
  const APPSTLE_RADIOS_SEL = 'input[name="selling_plan"]';
  const STICKY_PRICE_WRAPPER_SEL = '[id^="Price-Alt-"]';

  function getStickyPriceWrapper() {
    return document.querySelector(STICKY_PRICE_WRAPPER_SEL);
  }

  function getAppstleActivePrice() {
    const subPrice = document.querySelector(APPSTLE_ACTIVE_PRICE_SEL);
    if (subPrice && subPrice.offsetParent !== null) {
      return subPrice.textContent.trim();
    }
    const oneTimePrice = document.querySelector(APPSTLE_ONETIME_PRICE_SEL);
    if (oneTimePrice && oneTimePrice.offsetParent !== null) {
      return oneTimePrice.textContent.trim();
    }
    return null;
  }

  function getAppstleOneTimePrice() {
    const oneTimePrice = document.querySelector(APPSTLE_ONETIME_PRICE_SEL);
    if (oneTimePrice && oneTimePrice.offsetParent !== null) {
      return oneTimePrice.textContent.trim();
    }
    return null;
  }

  function updateStickyCartPrice(activePriceText, regularPriceText) {
    const wrapper = getStickyPriceWrapper();
    if (!wrapper) return;

    const salePriceEl = wrapper.querySelector('.price__sale .price-item--sale, .price-item--sale');
    const regularPriceEls = wrapper.querySelectorAll('.price-item--regular');

    if (salePriceEl && activePriceText) {
      salePriceEl.textContent = activePriceText;
    } else {
      const anyPriceItem = wrapper.querySelector('.price-item--regular, .price-item');
      if (anyPriceItem && activePriceText) {
        anyPriceItem.textContent = activePriceText;
      }
    }

    if (regularPriceText) {
      regularPriceEls.forEach(function (el) {
        el.textContent = regularPriceText;
      });
    }
  }

  function syncStickyCartPrices() {
    const activePrice = getAppstleActivePrice();
    const oneTimePrice = getAppstleOneTimePrice();
    updateStickyCartPrice(activePrice, oneTimePrice || activePrice);
  }

  // FIX: update ALL product-form hidden inputs, not just the first one.
  // The sticky cart has its own separate <product-form> component with its
  // own hidden input[name="id"]. querySelector() only grabbed the main form,
  // leaving the sticky cart permanently stuck on the server-rendered default
  // variant (1-pack), which caused the CAPI 422 on 2-pack / 3-pack adds.
  function updateAllFormVariantIds(variantId) {
    document.querySelectorAll('form.shopify-product-form input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
  }

  function handleRadioChange() {
    setTimeout(function () {
      syncStickyCartPrices();
    }, 80);
  }

  function bindRadioListeners() {
    document.querySelectorAll(APPSTLE_RADIOS_SEL).forEach(function (radio) {
      radio.addEventListener('change', handleRadioChange);
    });
  }

  function observeAppstleWidget() {
    const widget = document.querySelector('.appstle_sub_widget');
    if (!widget) return;

    const observer = new MutationObserver(function (mutations) {
      for (const m of mutations) {
        if (m.type === 'characterData' || m.type === 'childList') {
          syncStickyCartPrices();
          break;
        }
      }
    });

    observer.observe(widget, {
      subtree: true,
      childList: true,
      characterData: true,
    });
  }

  function bindVariantChangeListener() {
    document.addEventListener('variant:change', function () {
      setTimeout(function () {
        syncStickyCartPrices();
      }, 150);
    });
  }

  // FIX: also call updateAllFormVariantIds() when a bundle radio changes,
  // so the sticky cart's hidden input tracks the selected variant.
  function bindBundleOptionListeners() {
    document.querySelectorAll('[name^="bundle-option-"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var variantId = this.value;
        setTimeout(function () {
          syncStickyCartPrices();
          updateAllFormVariantIds(variantId); // FIX: was missing
        }, 150);
      });
    });
  }

  // FIX: use querySelectorAll to update BOTH the main form AND the sticky cart form.
  // Previously querySelector only updated the first product-form (main form).
  function forceDefaultVariantOnLoad() {
    const selectedRadio = document.querySelector('[name^="bundle-option-"]:checked');
    if (!selectedRadio) return;

    const variantId = selectedRadio.value;

    // FIX: was document.querySelector — now updates all forms
    updateAllFormVariantIds(variantId);

    // Still dispatch change on the first form to trigger theme listeners
    const firstFormInput = document.querySelector('form.shopify-product-form input[name="id"]');
    if (firstFormInput) {
      firstFormInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function init() {
    syncStickyCartPrices();
    bindRadioListeners();
    observeAppstleWidget();
    bindVariantChangeListener();
    bindBundleOptionListeners();
    forceDefaultVariantOnLoad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 400);
    });
  } else {
    setTimeout(init, 400);
  }
})();